import { render, staticRenderFns } from "./WebsitesLayout.vue?vue&type=template&id=b7e80b10&scoped=true"
import script from "./WebsitesLayout.vue?vue&type=script&lang=js"
export * from "./WebsitesLayout.vue?vue&type=script&lang=js"
import style0 from "./WebsitesLayout.vue?vue&type=style&index=0&id=b7e80b10&prod&scoped=true&lang=css"
import style1 from "./WebsitesLayout.vue?vue&type=style&index=1&id=b7e80b10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e80b10",
  null
  
)

export default component.exports